// class VatToggleButton extends HTMLElement {
//   constructor() {
//     super();
//     this.checkbox = null;
//     this.cartTable = null;
//   }

//   connectedCallback() {
//     // Get references to elements
//     this.checkbox = this.querySelector(".vat-calculation-checkbox");
//     this.cartTable = document.querySelector("variant-cart-table");

//     if (!this.checkbox) {
//       console.error("VAT checkbox not found");
//       return;
//     }

//     // Load saved state from sessionStorage
//     this.loadState();

//     // Add event listener for toggle
//     this.checkbox.addEventListener("change", this.handleToggle.bind(this));
//   }

//   loadState() {
//     // Load saved state from sessionStorage
//     const savedState = sessionStorage.getItem("vatToggleState");
//     console.log(savedState);

//     if (savedState !== null) {
//       this.checkbox.checked = savedState === "false";
//     } else {
//       // Default state (can be customized)
//       this.checkbox.checked = true;
//     }

//     // Apply initial state to cart table
//     this.updateCartTable();
//   }

//   saveState() {
//     // Save state to sessionStorage
//     sessionStorage.setItem("vatToggleState", this.checkbox.checked);
//   }

//   handleToggle(event) {
//     // Save the state
//     this.saveState();

//     // Update cart table visibility
//     this.updateCartTable();
//   }

//   updateCartTable() {
//     if (!this.cartTable) return;

//     const isVatIncluded = this.checkbox.checked;

//     // Toggle classes on cart table
//     if (isVatIncluded) {
//       this.cartTable.classList.add("vat-included");
//       this.cartTable.classList.remove("vat-excluded");
//     } else {
//       this.cartTable.classList.add("vat-excluded");
//       this.cartTable.classList.remove("vat-included");
//     }
//   }

//   disconnectedCallback() {
//     // Clean up event listener
//     if (this.checkbox) {
//       this.checkbox.removeEventListener("change", this.handleToggle.bind(this));
//     }
//   }
// }

// // Register the custom element
// if (!customElements.get("vat-toggle-button")) {
//   customElements.define("vat-toggle-button", VatToggleButton);
// }

class VatToggleButton extends HTMLElement {
  #checkbox = null;
  #cartTable = null;
  #handleToggle = null;

  connectedCallback() {
    this.#checkbox = this.querySelector(".vat-calculation-checkbox");
    this.#cartTable = document.querySelector("variant-cart-table");

    if (!this.#checkbox) {
      console.error("VAT checkbox not found");
      return;
    }

    // Default to VAT included; only override if explicitly saved as excluded
    const savedState = sessionStorage.getItem("vatToggleState");
    this.#checkbox.checked = savedState !== "false";

    this.#updateCartTable();

    this.#handleToggle = () => {
      // Only persist state when VAT is excluded; clear when re-included
      if (!this.#checkbox.checked) {
        sessionStorage.setItem("vatToggleState", "false");
      } else {
        sessionStorage.removeItem("vatToggleState");
      }
      this.#updateCartTable();
    };

    this.#checkbox.addEventListener("change", this.#handleToggle);
  }

  #updateCartTable() {
    if (!this.#cartTable) return;
    this.#cartTable.classList.toggle("vat-included", this.#checkbox.checked);
    this.#cartTable.classList.toggle("vat-excluded", !this.#checkbox.checked);
  }

  disconnectedCallback() {
    this.#checkbox?.removeEventListener("change", this.#handleToggle);
  }
}

if (!customElements.get("vat-toggle-button")) {
  customElements.define("vat-toggle-button", VatToggleButton);
}
